import type { OrganizationProviderConfig } from '@openx/components-organization/lib/utils/context/OrganizationContext';
import { useApiKeyCreate } from './utils/useApiKeyCreate';
import { useApiKeyDelete } from './utils/useApiKeyDelete';
import { useCreateOrganization } from './utils/useCreateOrganization';
import { useDspSeatsFetch } from './utils/useDspSeatsFetch';
import { useDspsFetch } from './utils/useDspsFetch';
import { useEditOrganization } from './utils/useEditOrganization';
import { useGetDefaultParentOrganizationId } from './utils/useGetDefaultParentOrganizationId';
import { useGetOrganizationsTableData } from './utils/useGetOrganizationsTableData';
import { useOrganizationApiKeysFetch } from './utils/useOrganizationApiKeysFetch';
import { useOrganizationFetch } from './utils/useOrganizationFetch';
import { useOrganizationPageHeaderActions } from './utils/useOrganizationPageHeaderActions';
import { useOrganizationPermissions } from './utils/useOrganizationPermissions';
import { useOrganizationPixelMetricsFetch } from './utils/useOrganizationPixelMetricsFetch';
import { useOrganizationsListFetch } from './utils/useOrganizationsListFetch';
import { useOrganizationUsersFetch } from './utils/useOrganizationUsersFetch';

export const organizationConfig: OrganizationProviderConfig = {
  isOa: true,
  useOrganizationFetch,
  useOrganizationsListFetch,
  useOrganizationUsersFetch,
  useOrganizationPageHeaderActions,
  useGetOrganizationsTableData,
  useOrganizationApiKeysFetch,
  useOrganizationPixelMetricsFetch,
  useApiKeyDelete,
  useGetDefaultParentOrganizationId,
  useCreateOrganization,
  useEditOrganization,
  useOrganizationPermissions,
  useApiKeyCreate,
  useDspsFetch,
  useDspSeatsFetch,
};
